// Utilitaires SEO pour Edutio
export const SITE_CONFIG = {
  baseUrl: 'https://www.edutio.fr',
  siteName: 'Edutio',
  defaultTitle: 'Edutio | Logiciel de gestion pour CFA et centres de formation',
  defaultDescription: 'Logiciel de gestion pour CFA : automatisez vos contrats d\'apprentissage, CERFA, connexion OPCO, émargement en ligne et facturation. Solution digitale utilisée par des CFA en France.',
  defaultImage: '/og-image.png',
  twitterHandle: '@edutio_fr',
  language: 'fr',
  locale: 'fr_FR'
};

// Configuration des pages et leurs métadonnées SEO
export const PAGES_SEO_CONFIG = {
  '/': {
    title: 'Edutio | Logiciel de gestion pour CFA, écoles et organismes de formation',
    description: 'Logiciel de gestion pour CFA : automatisez vos contrats d\'apprentissage, génération CERFA, connexion OPCO, émargement en ligne et facturation. Essai gratuit.',
    keywords: 'logiciel CFA, logiciel gestion CFA, émargement en ligne, contrat apprentissage, OPCO, CERFA automatique, gestion alternance, signature présence',
    priority: 1.0,
    changefreq: 'weekly'
  },
  '/forfaits': {
    title: 'Tarifs Edutio | Prix logiciel CFA transparent, sans engagement',
    description: 'Tarifs Edutio adaptés à la taille de votre CFA. Prix transparent, sans frais cachés. Essai gratuit 14 jours. À partir de 0€/mois.',
    keywords: 'tarifs logiciel CFA, prix gestion alternance, forfait CFA, abonnement formation professionnelle',
    priority: 0.8,
    changefreq: 'monthly'
  },
  '/emargement-assiduite': {
    title: 'Émargement en ligne & Signature présence | Logiciel CFA Edutio',
    description: 'Émargement numérique pour CFA : signature de présence en ligne, QR code, géolocalisation. Suivi assiduité en temps réel. Conforme Qualiopi. Essayez gratuitement.',
    keywords: 'émargement en ligne, émargement numérique, signature présence, émargement CFA, feuille présence digitale, QR code présence, assiduité alternants',
    priority: 0.9,
    changefreq: 'monthly'
  },
  '/contrat-apprentissage': {
    title: 'Contrat d\'apprentissage automatisé | Génération CERFA | Edutio',
    description: 'Automatisez vos contrats d\'apprentissage : génération CERFA automatique, envoi OPCO en 1 clic, suivi en temps réel.',
    keywords: 'contrat apprentissage, CERFA automatique, logiciel contrat alternance, gestion contrat CFA, envoi OPCO automatique',
    priority: 0.9,
    changefreq: 'monthly'
  },
  '/opco': {
    title: 'Connexion OPCO automatisée | Facturation & Suivi | Edutio',
    description: 'Connexion directe aux 11 OPCO : envoi dossiers automatique, suivi financements, facturation simplifiée. OPCO2i, Atlas, Akto, OPCO EP et plus.',
    keywords: 'connexion OPCO, facturation OPCO, envoi dossier OPCO, suivi financement alternance, OPCO2i, Atlas, Akto',
    priority: 0.9,
    changefreq: 'monthly'
  },
  '/actualites': {
    title: 'Actualités formation professionnelle - Blog Edutio CFA',
    description: 'Suivez l\'actualité de la formation professionnelle et de l\'apprentissage. Conseils, réglementation et bonnes pratiques pour les CFA.',
    keywords: 'actualités formation, blog CFA, apprentissage, réglementation',
    priority: 0.6,
    changefreq: 'weekly'
  },
  '/prospection-leads': {
    title: 'Prospection & Leads - Gestion des prospects pour CFA | Edutio',
    description: 'Optimisez votre prospection avec Edutio. Gestion des leads, suivi des prospects et conversion pour votre centre de formation. CRM intégré spécialisé CFA.',
    keywords: 'prospection CFA, gestion leads, suivi prospects, CRM formation, conversion leads',
    priority: 0.7,
    changefreq: 'monthly'
  },
  '/rapports-statistiques': {
    title: 'Rapports & Statistiques - Analytics pour centres de formation CFA | Edutio',
    description: 'Générez des rapports détaillés et analysez les performances de votre CFA avec Edutio. Statistiques en temps réel, tableaux de bord personnalisés et KPI formation.',
    keywords: 'rapports CFA, statistiques formation, analytics CFA, tableaux de bord, KPI formation professionnelle',
    priority: 0.7,
    changefreq: 'monthly'
  },
  '/gestion-documents': {
    title: 'Gestion de Documents - Dématérialisation pour CFA | Edutio',
    description: 'Dématérialisez et centralisez tous vos documents de formation avec Edutio. Gestion électronique, signature numérique et archivage sécurisé pour CFA.',
    keywords: 'gestion documents CFA, dématérialisation formation, GED CFA, signature électronique, archivage numérique',
    priority: 0.7,
    changefreq: 'monthly'
  },
  '/contact': {
    title: 'Demander une démo Edutio | Contact équipe commerciale',
    description: 'Demandez une démonstration gratuite d\'Edutio. Notre équipe vous présente le logiciel de gestion CFA en 30 minutes. Réponse sous 24h.',
    keywords: 'démo Edutio, contact logiciel CFA, démonstration gestion alternance, essai gratuit CFA',
    priority: 0.8,
    changefreq: 'monthly'
  },
  '/cgu': {
    title: 'Conditions Générales d\'Utilisation - CGU Edutio',
    description: 'Consultez les conditions générales d\'utilisation de la plateforme Edutio. Modalités d\'accès, droits et obligations des utilisateurs.',
    keywords: 'CGU, conditions générales, utilisation, Edutio, mentions légales',
    priority: 0.3,
    changefreq: 'yearly'
  },
  '/confidentialite': {
    title: 'Politique de Confidentialité - Protection des données Edutio',
    description: 'Découvrez notre politique de confidentialité et de protection des données personnelles. Conformité RGPD pour les centres de formation.',
    keywords: 'confidentialité, RGPD, protection données, vie privée, Edutio',
    priority: 0.3,
    changefreq: 'yearly'
  }
};

// Fonction pour générer les structured data pour un article
export const generateArticleStructuredData = (article, category = null) => {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": article.title,
    "description": article.excerpt || article.description,
    "image": article.cover_image ? `${SITE_CONFIG.baseUrl}/api/files/articles/${article.id}/${article.cover_image}` : `${SITE_CONFIG.baseUrl}${SITE_CONFIG.defaultImage}`,
    "datePublished": article.created,
    "dateModified": article.updated,
    "author": {
      "@type": "Organization",
      "name": SITE_CONFIG.siteName
    },
    "publisher": {
      "@type": "Organization",
      "name": SITE_CONFIG.siteName,
      "logo": {
        "@type": "ImageObject",
        "url": `${SITE_CONFIG.baseUrl}/logo.png`
      }
    },
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `${SITE_CONFIG.baseUrl}/article/${article.slug || article.id}`
    },
    "articleSection": category?.name || "Formation professionnelle",
    "keywords": `${article.title}, formation professionnelle, CFA, apprentissage${category?.name ? `, ${category.name}` : ''}`,
    "inLanguage": SITE_CONFIG.language
  };
};

// Fonction pour générer le sitemap XML (statique + articles dynamiques)
export const generateSitemap = async (articlesService = null) => {
  const allPages = { ...PAGES_SEO_CONFIG };
  const currentDate = new Date().toISOString().split('T')[0];
  
  let sitemap = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">`;

  // Ajouter les pages statiques
  Object.entries(allPages).forEach(([path, config]) => {
    sitemap += `
  <url>
    <loc>${SITE_CONFIG.baseUrl}${path}</loc>
    <lastmod>${currentDate}</lastmod>
    <changefreq>${config.changefreq}</changefreq>
    <priority>${config.priority}</priority>
  </url>`;
  });

  // Ajouter les articles dynamiquement si le service est fourni
  if (articlesService) {
    try {
      // Récupérer tous les articles (pagination pour gérer de gros volumes)
      let page = 1;
      let hasMore = true;
      
      while (hasMore) {
        const result = await articlesService.getAll({ 
          page, 
          perPage: 100, // Récupérer par batch de 100
          sort: '-updated' 
        });
        
        result.items.forEach(article => {
          const articleDate = new Date(article.updated).toISOString().split('T')[0];
          sitemap += `
  <url>
    <loc>${SITE_CONFIG.baseUrl}/article/${article.slug || article.id}</loc>
    <lastmod>${articleDate}</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.6</priority>
  </url>`;
        });
        
        hasMore = result.items.length === result.perPage && page < result.totalPages;
        page++;
      }
    } catch (error) {
      console.error('Erreur lors de la génération du sitemap avec les articles:', error);
      // Continue sans les articles en cas d'erreur
    }
  }

  sitemap += `
</urlset>`;

  return sitemap;
};

// Fonction pour générer les structured data JSON-LD
export const generateStructuredData = (pageConfig, path = '/') => {
  const baseStructuredData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": `${SITE_CONFIG.baseUrl}/#organization`,
        "name": SITE_CONFIG.siteName,
        "url": SITE_CONFIG.baseUrl,
        "logo": {
          "@type": "ImageObject",
          "url": `${SITE_CONFIG.baseUrl}/logo.png`
        },
        "sameAs": [
          "https://www.linkedin.com/company/edutio",
          "https://twitter.com/edutio_fr"
        ]
      },
      {
        "@type": "WebSite",
        "@id": `${SITE_CONFIG.baseUrl}/#website`,
        "url": SITE_CONFIG.baseUrl,
        "name": SITE_CONFIG.siteName,
        "description": SITE_CONFIG.defaultDescription,
        "publisher": {
          "@id": `${SITE_CONFIG.baseUrl}/#organization`
        },
        "inLanguage": SITE_CONFIG.language
      },
      {
        "@type": "WebPage",
        "@id": `${SITE_CONFIG.baseUrl}${path}#webpage`,
        "url": `${SITE_CONFIG.baseUrl}${path}`,
        "name": pageConfig.title,
        "description": pageConfig.description,
        "isPartOf": {
          "@id": `${SITE_CONFIG.baseUrl}/#website`
        },
        "inLanguage": SITE_CONFIG.language
      }
    ]
  };

  // Ajouter des structured data spécifiques selon le type de page
  if (path === '/') {
    baseStructuredData["@graph"].push({
      "@type": "SoftwareApplication",
      "name": "Edutio",
      "description": "Plateforme SaaS pour la gestion des dossiers d'apprentissage dans les CFA",
      "applicationCategory": "BusinessApplication",
      "operatingSystem": "Web, iOS, Android",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "EUR",
        "description": "Essai gratuit disponible"
      }
    });
  }

  if (path === '/contact') {
    baseStructuredData["@graph"].push({
      "@type": "ContactPage",
      "name": "Contact Edutio",
      "description": "Contactez l'équipe Edutio pour une démonstration"
    });
  }

  return baseStructuredData;
};

// Hook personnalisé pour les meta tags
export const usePageSEO = (path) => {
  const pageConfig = PAGES_SEO_CONFIG[path] || PAGES_SEO_CONFIG['/'];
  
  return {
    title: pageConfig.title,
    description: pageConfig.description,
    keywords: pageConfig.keywords,
    canonical: `${SITE_CONFIG.baseUrl}${path}`,
    structuredData: generateStructuredData(pageConfig, path)
  };
};